import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { TransactionReportContainer } = await import('@containers/Payment/TransactionReport');
    return {
        Component: TransactionReportContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
